import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ISendingMessage, IMailingResult } from '@interfaces/ISendingMessage';

@Injectable({
  providedIn: 'root',
})
export class MailingsService {
  constructor(private _http: HttpClient) {}

  createMailing({
    mailing,
  }: {
    mailing: ISendingMessage;
    type?: 'Telegram';
  }): Observable<ISendingMessage> {
    const url = `${environment.baseUrl}api/v1/notifications/telegram/`;
    return this._http.post<ISendingMessage>(url, mailing);
  }

  getMailings(): Observable<ISendingMessage[]> {
    const url = `${environment.baseUrl}api/v1/notifications/telegram/`;
    return this._http.get<ISendingMessage[]>(url);
  }

  getMailing(id: number): Observable<ISendingMessage> {
    const url = `${environment.baseUrl}api/v1/notifications/telegram/${id}/`;
    return this._http.get<ISendingMessage>(url);
  }

  getResults(id: number): Observable<IMailingResult[]> {
    const url = `${environment.baseUrl}api/v1/notifications/results/?notification_id=${id}`;
    return this._http.get<IMailingResult[]>(url);
  }

  updateMailing(
    id: number,
    data: ISendingMessage
  ): Observable<ISendingMessage> {
    const url = `${environment.baseUrl}api/v1/notifications/telegram/${id}/`;
    return this._http.put<ISendingMessage>(url, data);
  }
}
